import { Button, Grid, MenuItem, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import { genders } from "../../../utils/setting";
import CountryCode from "../../countryCode";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputAddress from "../../suggestAddress";
import { edit as styles } from "./styles";

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visitor: {
        city: "",
        address: "",
        country: "",
        state: "",
        district: "",
        ...this.props.visitor,
      },
    };
  }
  componentDidMount = () => {
    this.setState({
      visitor: {
        city: "",
        address: "",
        country: "",
        state: "",
        district: "",
        ...this.props.visitor,
      },
    });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.visitor !== this.props.visitor) {
      this.setState({
        visitor: {
          city: "",
          address: "",
          country: "",
          state: "",
          district: "",
          ...nextProps.visitor,
        },
      });
    }
  }
  handelSubmit = async () => {
    const { visitor } = this.state;
    this.loading.startLoading();
    const { t } = this.props;
    let check = await this.props.update({
      snackbar: this.snackbar,
      visitor: visitor,
      t: t,
    });
    if (check && check.code) {
      this.setState({
        visitor: {
          city: "",
          address: "",
          country: "",
          state: "",
          district: "",
          ...check.data,
        },
      });
      this.props.handleClose();
    }
    this.loading.stopLoading();
  };

  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let { visitor } = this.state;
    visitor[name] = value;
    this.setState({ visitor: visitor });
  };
  handleChangeAddress = (value) => {
    let { visitor } = this.state;
    visitor.longtitude = value.lng;
    visitor.latitude = value.lat;
    delete value.lat;
    delete value.lng;
    visitor = { ...visitor, ...value };
    this.setState({ visitor });
  };
  handleCountryCode = (name, value) => {
    let { visitor } = this.state;
    visitor[name] = value;
    this.setState({ visitor });
  };

  render() {
    const { classes, handleClose, t } = this.props;
    let { visitor } = this.state;
    return (
      <Paper square={true} className={classes.editFormContainer}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />

        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} alignItems="flex-end">
              <Grid item xs={6} sm={3}>
                <CountryCode
                  margin="normal"
                  code={visitor.countryCode}
                  handleCountryCode={this.handleCountryCode}
                />
              </Grid>
              <Grid item xs={6} sm={9}>
                <InputFormat
                  required
                  label={t("visitor_phone")}
                  name="phone"
                  margin="normal"
                  fullWidth
                  value={visitor.phone}
                  onChange={this.handleChange}
                  className={classes.textField}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputFormat
              required
              label={t("visitor_name")}
              name="name"
              margin="normal"
              fullWidth
              value={visitor.name}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              required
              label={t("visitor_email")}
              name="email"
              margin="normal"
              fullWidth
              value={visitor.email}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              // required
              label={t("visitor_age")}
              name="age"
              margin="normal"
              fullWidth
              value={visitor.age}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              select
              native
              // required
              label={t("visitor_gender")}
              name="gender"
              margin="normal"
              fullWidth
              value={visitor.gender}
              onChange={this.handleChange}
              className={classes.textField}
            >
              {genders.map((gender, index) => (
                <MenuItem key={index} value={gender.value}>
                  {t(gender.label)}
                </MenuItem>
              ))}
            </InputFormat>
          </Grid>

          <Grid item xs={12} sm={5}>
            <InputFormat
              label={t("visitor_socialId")}
              name="socialId"
              margin="normal"
              fullWidth
              value={visitor.socialId}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <InputFormat
              label={t("visitor_socialLink")}
              name="socialLink"
              margin="normal"
              fullWidth
              value={visitor.socialLink}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              label={t("visitor_ip")}
              name="ip"
              margin="normal"
              fullWidth
              value={visitor.ip}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputFormat
              label={t("visitor_fromType")}
              name="fromType"
              margin="normal"
              fullWidth
              value={visitor.fromType}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <InputFormat
              disabled
              label={t("visitor_userAgent")}
              name="userAgent"
              margin="normal"
              fullWidth
              value={visitor.userAgent}
              onChange={this.handleChange}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputAddress
              multiline
              name="address"
              label={t("visitor_address")}
              margin="normal"
              value={visitor.address}
              handleChange={this.handleChangeAddress}
              className={classes.textField}
              required
              InputProps={{
                classes: {
                  input: classes.inputMultiline,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("visitor_country")}
                  name="country"
                  margin="normal"
                  fullWidth
                  value={visitor.country}
                  onChange={this.handleChange}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("visitor_state")}
                  name="state"
                  margin="normal"
                  fullWidth
                  value={visitor.state}
                  onChange={this.handleChange}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  label={t("visitor_city")}
                  name="city"
                  margin="normal"
                  fullWidth
                  value={visitor.city}
                  onChange={this.handleChange}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  label={t("visitor_district")}
                  name="district"
                  margin="normal"
                  fullWidth
                  value={visitor.district}
                  onChange={this.handleChange}
                  className={classes.textField}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.backgroundButton}>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            {t("visitor_cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 8 }}
            onClick={this.handelSubmit}
          >
            {t("visitor_update")}
          </Button>
        </div>
      </Paper>
    );
  }
}

EditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  one_visitor: state.visitors.one_visitor,
});

const mapDispatch = (dispatch) => ({
  getList: dispatch.visitors.getList,
  update: dispatch.visitors.update,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(EditForm)));
